export default {
  brand: {
    company: 'SytoonTech',
    companyTagline: '公用事业软件工程',
    platform: '电力技术资料分享平台',
    platformShort: '资料平台'
  },
  nav: {
    home: '首页',
    products: '产品',
    solutions: '解决方案',
    about: '关于我们',
    contact: '联系我们',
    platform: '资料平台',
    articles: '资料',
    topics: '专题',
    software: '软件',
    projects: '项目',
    free: '免费',
    paid: '积分',
    login: '登录',
    register: '注册',
    logout: '退出',
    center: '个人中心',
    upload: '上传',
    buyPoints: '买积分',
    langEn: 'EN',
    langZh: '中文'
  },
  common: {
    learnMore: '了解更多',
    contactUs: '联系我们',
    viewAll: '查看全部',
    search: '搜索',
    submit: '提交',
    back: '返回',
    loading: '加载中…',
    empty: '暂无数据',
    cancel: '取消',
    confirm: '确认',
    download: '下载',
    preview: '预览',
    remove: '移除',
    all: '全部',
    free: '免费',
    points: '积分',
    pointsN: '{n} 积分',
    email: '邮箱',
    category: '分类',
    type: '类型',
    sort: '排序',
    loadFailed: '加载失败',
    operationFailed: '操作失败',
    downloadFailed: '下载失败',
    downloadStarted: '开始下载',
    copyFailed: '复制失败',
    alreadyRedeemed: '已兑换过',
    redeemSuccess: '兑换成功',
    pointsShort: '{n}分',
    userFallback: '用户'
  },
  corporate: {
    home: {
      title: 'SytoonTech — STS预付费、AMI与电力计量软件',
      description: 'SytoonTech 专注 STS 预付费、AMI 采集、MDM、FDM、电表管理及公用事业运营软件研发与交付，服务全球电力企业。',
      keywords: 'SytoonTech,STS预付费,AMI,MDM,FDM,电表管理,公用事业软件,智能计量,能源软件',
      heroTitle: '智能计量软件，可靠交付。',
      heroSub: '从 STS 预付费、AMI 采集到表计资产与公用事业运营——面向现场与后台的可落地软件能力。',
      heroSlides: '首页背景图',
      heroSlideN: '切换到第 {n} 张',
      ctaProducts: '浏览解决方案',
      ctaContact: '联系我们',
      pillarsTitle: '我们的解决方案',
      solutionsIntro: '围绕预付费计量、AMI 数据、表计全生命周期与日常运营场景打造的专业软件。',
      pillar1Title: 'STS 预付费计量',
      pillar1Body: '售电、令牌全生命周期与表端预付费控制，服务电力公用事业。',
      pillar2Title: 'AMI 与用能数据',
      pillar2Body: '覆盖表计群的采集、校验与运行可视能力。',
      pillar3Title: '电表管理',
      pillar3Body: '从仓库到现场的资产台账、库存与装拆换流程。',
      featureEyebrow: '资料平台',
      featureTitle: '面向电力行业的技术资料库',
      featureBody: '在 SytoonTech 资料平台获取标准规范、计量实践、软件下载与项目需求信息。',
      missionTitle: '把可信工程写进每一次交付',
      missionBody: '我们与公用事业与解决方案伙伴合作，交付生产级计量与能源软件——从核心引擎到运营控制台权责清晰。',
      missionCta: '了解 SytoonTech'
    },
    products: {
      title: '产品 — STS预付费、AMI、MDM、FDM与电表软件 | SytoonTech',
      description: '了解 SytoonTech 产品：STS 预付费、AMI 采集、MDM、FDM、电表管理、表计配置、公用事业运营与移动 App。',
      keywords: 'STS预付费软件,AMI软件,MDM,FDM,表计配置,电表管理,公用事业App,智能计量产品',
      heading: '产品组合',
      intro: '覆盖预付费计量、AMI、电能数据、现场设备、运营管理与移动端应用。',
      stsName: 'STS 预付费计量软件',
      stsSummary: '覆盖售电、Token 生成与表计对接的 STS 预付费整体方案。',
      amiName: 'AMI 电能量采集软件',
      amiSummary: '可扩展的 AMI 主站与采集软件，支持抄表、数据校验与用能分析。',
      mmsName: '电表管理系统',
      mmsSummary: '表计资产、库存、安装与全生命周期集中管理。',
      umsName: '公用事业管理软件',
      umsSummary: '面向客服、外勤与后台运营的模块化管理软件。',
      mdmName: 'MDM 电能数据管理',
      mdmSummary: 'VEE、聚合与计费就绪数据服务，支撑 CIS 与分析应用。',
      fdmName: 'FDM 现场设备管理',
      fdmSummary: '面向表计群的固件、参数、开通调试与远程控制。',
      appName: '公用事业移动 App',
      appSummary: '客户、代理与现场 App，对接预付费、AMI 与电表系统。',
      cfgName: '电表配置软件',
      cfgSummary: '参数、费率与 STS 密钥配置，支持实验室与现场开通调试。',
      casesTitle: '产品案例',
      casesIntro: '海外典型交付：智能预付费、智能用电管理与 AMI 采集。',
      caseAfricaRegion: '非洲',
      caseAfricaTitle: '某国智能预付费系统',
      caseAfricaBody: '为国家级电力项目提供 STS 预付费售电、令牌服务与电表对接。',
      caseMeRegion: '中东',
      caseMeTitle: '智能用电管理系统',
      caseMeBody: '覆盖客服、现场作业与计量后台流程的公用事业运营管理平台。',
      caseThRegion: '泰国',
      caseThTitle: 'AMI 采集系统',
      caseThBody: '区域智能表项目的 AMI 主站采集、数据校验与运行监控。'
    },
    productDetail: {
      capabilities: '核心能力',
      standards: '标准与协议',
      scenarios: '典型场景',
      cta: '预约咨询'
    },
    about: {
      title: '关于 SytoonTech — 电力行业软件与咨询',
      description: '关于 SytoonTech：海外电力咨询、STS/AMI 软件研发、系统集成与长期运维，服务全球公用事业客户。',
      keywords: '关于SytoonTech,电力行业咨询,公用事业软件公司,STS AMI开发,计量软件厂商',
      heading: '关于我们',
      body1: '专注电力与公用事业数字化——预付费计量、AMI 采集与表计运营软件。',
      body2: '兼具 STS/AMI 领域经验与工程交付能力，覆盖架构、研发、集成与海外项目长期支持。',
      servicesTitle: '我们做什么',
      servicesIntro: '咨询、软件交付与全生命周期支持。',
      s1Title: '海外电力行业咨询',
      s1Body: '计量方案、预付费/AMI 路线图、厂商评估与多国部署本地化建议。',
      s2Title: '相关软件研发',
      s2Body: 'STS 引擎、AMI/MDMS 流程、电表管理与运营控制台，可靠可审计。',
      s3Title: '集成与项目落地',
      s3Body: '对接电表、售电、支付与企业系统，支持试点到割接落地。',
      s4Title: '运维与持续演进',
      s4Body: '监控、补丁、升级与远程支持，保障系统上线后稳定运行。',
      capabilityTitle: '能力范围',
      c1: '海外电力与计量项目咨询',
      c2: 'STS 预付费 / AMI / 电表管理经验',
      c3: '定制与产品化公用事业软件',
      c4: '表计、售电与企业系统集成',
      c5: '本地化与多市场部署支持',
      c6: '长期维护与远程技术支持'
    },
    contact: {
      title: '联系 SytoonTech — 电力计量项目咨询',
      description: '联系 SytoonTech，咨询 STS 预付费、AMI、MDM、表计配置与公用事业软件项目。邮箱 sytoontech@gmail.com。',
      keywords: '联系SytoonTech,STS预付费咨询,AMI项目,公用事业软件联系,计量咨询',
      heading: '联系我们',
      intro: '请说明您的计量或公用事业软件需求，我们通常在工作日回复。',
      email: '邮箱',
      hours: '服务时间',
      hoursValue: '工作日 09:00 – 18:00（GMT+8）',
      note: '如需社区资料与文档下载，请通过页眉进入「资料平台」。',
      guestbookTitle: '留言咨询',
      guestbookIntro: '欢迎留下项目需求或反馈，我们通常在工作日查阅并回复。',
      guestbookName: '称呼',
      guestbookNamePh: '姓名或公司名称',
      guestbookContact: '联系方式',
      guestbookContactPh: '邮箱或电话',
      guestbookContent: '留言内容',
      guestbookContentPh: '请简要说明您的需求',
      guestbookRequired: '请完整填写各项内容。',
      guestbookSuccess: '提交成功，感谢您的留言。',
      guestbookFail: '提交失败，请稍后再试。'
    },
    footer: {
      rights: '版权所有。',
      platformHint: '需要技术资料与社区下载？',
      mission: '专注预付费、AMI 与运营场景的电力计量与能源软件。',
      allProducts: '全部产品',
      company: '公司',
      connect: '连接'
    }
  },
  platform: {
    seoTitle: '电力技术资料分享平台',
    seoDesc: '电力行业技术文档、标准规范、软件下载与项目需求分享平台，支持在线阅读与附件下载。',
    seoKeywords: '电力技术资料,电力标准,智能计量,STS预付费,AMI,技术文档下载,电力软件',
    homeTitle: '电力技术资料分享平台',
    homeDesc: '电力行业技术文档、标准规范、软件与项目需求的分享与获取。',
    searchPlaceholder: '搜索文档、标准、软件…',
    ctaFree: '浏览免费资料',
    ctaUpload: '上传资料',
    ctaRegister: '注册并送 50 积分',
    ctaUploadSoftware: '上传软件',
    ctaPublishProject: '发布项目需求',
    statTotal: '资料总量',
    statFree: '免费资料',
    statDownloads: '累计下载',
    sectionCategories: '资料分类',
    sectionFeatured: '本周必读',
    sectionTopics: '热门专题',
    sectionWeekly: '本周贡献榜',
    sectionArticles: '最新资料',
    sectionHot: '热门下载',
    sectionSoftware: '软件下载',
    sectionProjects: '项目需求',
    featuredDesc: '精选标准、计量与运维实践资料。',
    topicsDesc: '专题聚合，更快形成学习路径。',
    softwareDesc: '免费直接下载，积分软件兑换一次后可永久下载。',
    projectsDesc: '浏览项目需求，按需兑换后查看联系方式。',
    emptyFeatured: '暂无精选资料',
    emptySoftware: '暂无软件，登录后可上传安装包赚积分',
    emptyProjects: '暂无项目需求',
    topicFallback: '专题合集',
    articlesUnit: '篇资料',
    viewsUnit: '次浏览',
    uploadsUnit: '次上传',
    filesUnit: '个附件',
    budgetTbd: '预算待定',
    pointsHint: '上传内容赚积分，积分兑换优质技术文档。',
    footerNav: '快速导航',
    footerCats: '资料分类',
    footerContact: '联系我们',
    serviceHours: '服务时间',
    report: '内容举报',
    reportHint: '请在资料页点击「举报」，工作日 24 小时内处理。',
    layout: {
      admin: '管理后台',
      menu: '菜单',
      openMenu: '打开菜单',
      closeMenu: '关闭菜单',
      logoutSuccess: '已退出登录'
    },
    card: {
      featured: '本周必读',
      free: '免费',
      pointsN: '{n} 积分',
      attachmentsN: '{n} 个附件'
    },
    files: {
      needRedeem: '需兑换',
      preview: '预览',
      download: '下载',
      empty: '暂无附件'
    },
    articles: {
      title: '技术资料库',
      desc: '浏览电力行业专业技术文档，支持在线阅读和附件下载',
      seoTitle: '技术资料库 — 电力文档与标准',
      seoDesc: '浏览并搜索电力行业技术资料、标准规范与实践文档，支持在线阅读与附件下载。',
      seoKeywords: '电力技术资料库,电力标准规范,技术文档下载,智能计量资料',
      searchPlaceholder: '搜索标题、摘要或正文',
      allCategories: '全部分类',
      typePaid: '积分资料',
      sortRelevance: '综合相关',
      sortUpdated: '最新更新',
      sortDownloads: '下载最多',
      sortViews: '阅读最多',
      hot: '热门：',
      recent: '最近：',
      featuredResult: '本周必读 · 共 {n} 篇',
      keywordResult: '关键词「{keyword}」共 {n} 条结果',
      sortedByRelevance: ' · 已按相关度排序',
      emptyFeatured: '暂无本周必读，请稍后再看或浏览全部资料',
      emptyKeyword: '未找到「{keyword}」相关资料，试试分类或去上传',
      empty: '暂无符合条件的资料',
      goUpload: '去上传资料',
      registerUpload: '注册后上传',
      fallbackTitle: '热门资料推荐',
      suggestDoc: '资料',
      suggestCategory: '分类',
      suggestRecent: '最近',
      suggestHot: '热门'
    },
    articleDetail: {
      breadcrumbHome: '首页',
      breadcrumbArticles: '技术资料',
      free: '免费',
      pointsN: '{n} 积分',
      viewsN: '{n} 阅读',
      downloadsN: '{n} 下载',
      favorited: '已收藏',
      favorite: '收藏',
      copyShare: '复制分享文案',
      scanFavorite: '扫码收藏',
      report: '举报',
      teaserTitle: '公开摘要预览',
      teaserNote: '以上为约 200 字公开预览，完整正文与附件需兑换后查看',
      paidTitle: '积分资料',
      paidDesc: '本文需 {n} 积分兑换，兑换后可阅读全文并下载附件',
      yourPoints: '您当前有 {n} 积分',
      loginToRedeem: '请先 {login} 后使用积分兑换；也可 {register} 领取积分',
      loginLink: '登录',
      registerLink: '免费注册',
      needMorePoints: '还差 {n} 积分，{buy}',
      buyPointsNow: '立即购买积分',
      redeemWith: '使用 {n} 积分兑换',
      pointsInsufficient: '积分不足',
      buyPoints: '购买积分',
      registerFull: '注册查看全文',
      loginRedeem: '登录后兑换',
      attachments: '附件',
      qaTitle: '资料问答 ({n})',
      askQuestion: '我对这份资料有疑问',
      loginToAsk: '登录后提问',
      qaHint: '向作者提问；作者/管理员可回复并置顶优质回答',
      askPlaceholder: '描述你的疑问，例如：这份规范适用于 10kV 电缆接头吗？',
      submitQuestion: '提交问题',
      answered: '已回答',
      pending: '待回复',
      pinned: '置顶',
      official: '作者/官方',
      unpin: '取消置顶',
      pinAnswer: '置顶优质回答',
      authorReply: '作者回复',
      addAnswer: '补充回答',
      answerPlaceholder: '写下你的回答…',
      submitAnswer: '提交回答',
      qaEmpty: '还没有提问，遇到不清楚的地方就问一句吧',
      commentsTitle: '评论 ({n})',
      commentPlaceholder: '写下你的评论...',
      postComment: '发表评论',
      loginToComment: '{login} 后参与评论',
      commentsEmpty: '暂无评论，快来抢沙发吧',
      infoTitle: '资料信息',
      typePaid: '积分资料',
      typeFree: '免费资料',
      pointsNeeded: '所需积分',
      attachmentCount: '附件数量',
      attachmentCountN: '{n} 个',
      redeem: '积分兑换',
      unlocked: '已兑换',
      earnTitle: '赚取积分',
      earnDesc: '上传您的技术资料，审核通过即可获得积分奖励',
      earnCta: '上传资料赚积分',
      relatedHot: '同类热门',
      sameAuthor: '同作者资料',
      viewProfile: '查看主页',
      wxacodeTitle: '扫码收藏这份资料',
      wxacodeAlt: '小程序收藏码',
      wxacodeHint: '用微信扫码打开小程序，将自动收藏本资料',
      reportTitle: '举报不当内容',
      reportReason: '原因',
      reportSelect: '请选择',
      reportSecret: '疑似涉密',
      reportCopyright: '版权问题',
      reportSpam: '垃圾信息',
      reportOther: '其他',
      reportDetail: '说明',
      notPublished: '该资料暂未发布',
      notFound: '文章不存在',
      unfavorited: '已取消收藏',
      favoriteSuccess: '收藏成功，可在「我的收藏」查看',
      reportLogin: '请先登录后再举报',
      reportReasonRequired: '请选择举报原因',
      reportSuccess: '已提交，工作日 24 小时内处理',
      reportFailed: '举报失败',
      sharePrefix: '【电力技术资料】',
      shareCopied: '分享文案已复制（规范名 + 一句话价值）',
      shareCopyFailed: '复制失败，请手动复制浏览器地址栏链接',
      wxacodeFailed: '生成收藏码失败（请确认已配置小程序）',
      askSuccess: '问题已提交，作者收到后会回复',
      askFailed: '提问失败',
      answerSuccess: '回答已发布',
      answerFailed: '回答失败',
      pinnedSuccess: '已置顶',
      unpinnedSuccess: '已取消置顶',
      commentSuccess: '评论发表成功',
      commentFailed: '评论发表失败',
      redeemConfirm: '确认使用 {n} 积分兑换《{title}》？',
      redeemTitle: '积分兑换',
      redeemConfirmBtn: '确认兑换',
      alreadyUnlocked: '您已兑换过该资料',
      redeemResult: '兑换成功！消耗 {cost} 积分，剩余 {points} 积分',
      redeemFailed: '兑换失败',
      downloadFile: '开始下载：{name}',
      previewFailed: '预览失败'
    },
    software: {
      title: '软件下载',
      desc: '免费软件可直接下载，积分软件兑换一次后可永久下载',
      seoTitle: '软件下载 — 电力与计量工具',
      seoDesc: '电力与计量相关软件下载：免费直接下载，积分软件兑换后可永久下载。',
      seoKeywords: '电力软件下载,计量工具,STS工具,AMI软件,电力工具',
      uploadCta: '上传软件赚积分',
      searchPlaceholder: '搜索软件名称',
      typePlaceholder: '类型',
      platformPlaceholder: '平台',
      typePaid: '积分兑换',
      downloadsN: '{n} 次下载',
      empty: '暂无软件',
      platformTool: '工具',
      platformPlugin: '插件',
      platformOther: '其他'
    },
    softwareDetail: {
      breadcrumbHome: '首页',
      breadcrumbSoftware: '软件下载',
      version: '版本 {v}',
      downloadsN: '{n} 次下载',
      redeemWith: '使用 {n} 积分兑换',
      unlocked: '已兑换，可下载',
      packages: '安装包',
      downloadAfter: '兑换后下载',
      emptyPackages: '暂无安装包',
      pointsLowTitle: '积分不足',
      pointsLowConfirm: '积分不足，是否前往购买积分？',
      redeemConfirm: '确认使用 {n} 积分兑换《{name}》？',
      redeemTitle: '积分兑换'
    },
    projects: {
      title: '项目需求',
      desc: '发布项目需求，审核通过后展示。联系方式与附件需积分兑换后查看',
      seoTitle: '项目需求 — 电力与计量合作',
      seoDesc: '浏览电力与计量相关项目需求，审核通过后展示；联系方式与附件可按需兑换查看。',
      seoKeywords: '电力项目需求,计量项目,STS项目,AMI项目合作',
      publish: '发布项目',
      searchPlaceholder: '搜索项目',
      noSummary: '暂无简介',
      budget: '预算 {budget}',
      filesN: '{n} 个附件',
      viewsN: '{n} 次浏览',
      empty: '暂无项目'
    },
    projectDetail: {
      breadcrumbHome: '首页',
      breadcrumbProjects: '项目需求',
      pointsContact: '{n} 积分查看联系方式',
      freeView: '免费查看',
      budget: '预算 {budget}',
      viewsN: '{n} 次浏览',
      redeemContact: '使用 {n} 积分兑换联系方式',
      unlocked: '联系方式与附件已可见',
      requirement: '项目需求',
      techStack: '开发技术要求',
      extra: '其他说明',
      contact: '联系方式',
      phone: '电话：{phone}',
      email: '邮箱：{email}',
      contactHintPaid: '联系方式需 {n} 积分兑换后可见，请先登录并兑换',
      contactHintLogin: '请登录后查看联系方式',
      attachments: '附件',
      filesLocked: '共 {n} 个附件，兑换后可见',
      pointsLowTitle: '积分不足',
      pointsLowConfirm: '积分不足，是否前往购买积分？',
      redeemConfirm: '确认使用 {n} 积分兑换《{title}》的联系方式与附件？',
      redeemTitle: '积分兑换'
    },
    projectPublish: {
      breadcrumbHome: '首页',
      breadcrumbProjects: '项目需求',
      breadcrumbPublish: '发布项目',
      title: '发布项目需求',
      tip: '无需登录即可提交。审核通过后才会公开展示，联系方式与附件需积分兑换后才对其他人可见。',
      labelTitle: '项目标题',
      labelRequirement: '项目需求',
      requirementPlaceholder: '请描述项目具体需求',
      labelTech: '技术要求',
      techPlaceholder: '可选，如语言、框架、部署环境',
      labelBudget: '项目预算',
      budgetPlaceholder: '如 5-10 万，或面议',
      labelExtra: '其他说明',
      labelPhone: '联系电话',
      phonePlaceholder: '手机或座机',
      labelEmail: '联系邮箱',
      labelFiles: '附件',
      uploadFile: '上传附件',
      submitAudit: '提交审核',
      fillRequired: '请填写标题、需求、电话和邮箱',
      submitSuccess: '已提交，等待管理员审核'
    },
    topics: {
      title: '技术专题',
      desc: '按场景聚合资料与讨论，便于现场查阅与群转发',
      seoTitle: '技术专题',
      seoDesc: '电力技术专题合集：光伏并网、变电运维等场景资料与讨论',
      seoKeywords: '电力技术专题,光伏并网,变电运维,智能计量专题',
      fallbackSummary: '精选资料合集',
      articlesN: '{n} 篇资料',
      viewsN: '{n} 阅读',
      empty: '暂无已发布专题'
    },
    topicDetail: {
      breadcrumbHome: '首页',
      breadcrumbTopics: '专题',
      articlesN: '{n} 篇资料',
      viewsN: '{n} 阅读',
      copyShare: '复制分享文案',
      discussion: '置顶讨论',
      openDiscussion: '打开讨论帖',
      discussionFallback: '专题讨论帖',
      emptyComments: '暂无讨论，登录后可首发提问',
      commentPlaceholder: '围绕本专题提问或补充现场经验…',
      postComment: '发表讨论',
      loginToDiscuss: '{login} 后参与置顶讨论',
      loginLink: '登录',
      topicArticles: '专题资料',
      pinned: '置顶',
      emptyArticles: '暂无关联资料',
      notFound: '专题不存在',
      seoSuffix: '{title} - 电力技术专题',
      shareCopied: '分享文案已复制，可直接发群',
      posted: '已发表',
      postFailed: '发表失败',
      readLabel: '阅读：',
      summaryLabel: '摘要页：'
    },
    author: {
      fallbackTitle: '贡献者主页',
      bannerDesc: '上传数 · 下载影响力 · 收藏认可 · 公开等级徽章',
      joinedPrefix: '加入于',
      noBadges: '继续上传优质资料，解锁活跃贡献者 / 领域专家徽章',
      uploadAgain: '再传一篇',
      published: '已发布',
      totalDownloads: '累计下载',
      favorites: '获收藏',
      totalViews: '累计阅读',
      weekUploads: '本周上传',
      topCategories: '擅长分类：',
      categoryCount: '{name} · {n} 篇',
      badgeRules: '等级徽章规则（透明公开）',
      theirDocs: 'TA 的资料',
      totalArticles: '共 {n} 篇',
      emptyArticles: '暂无已发布资料',
      notFound: '贡献者不存在或已停用'
    },
    team: {
      print: '打印 / 另存为 PDF',
      toolbarHint: '面向培训主管，一页讲清怎么把班组拉进来。',
      brand: '电力技术资料分享平台',
      title: '给培训主管的一页说明',
      lead: '一次拉进一个班组，而不是一个个转发链接。',
      step1: '发邀请码。',
      step1Body: '注册双方各得积分，新同事当天就能兑换样例资料。',
      step2: '建班组资料包。',
      step2Body: '把本班常用规范放进只读包，群里发一个链接即可。',
      step3: '跟进问答。',
      step3Body: '资料旁可以直接提问，作者或管理员回复并置顶。',
      foot: '建议先选 1 个班组试点：邀请 5 人 + 1 个资料包（安全 / 并网 / 运维各 2 篇）。',
      packMeta: '{owner} 分享的班组资料包 · 只读 · {n} 篇',
      packFree: '免费',
      packPoints: '{n}积分',
      packEmpty: '资料包还是空的',
      packNotFound: '资料包不存在'
    }
  },
  auth: {
    login: {
      title: '用户登录',
      desc: '登录后可上传资料、赚取积分、兑换技术文档',
      username: '用户名',
      password: '密码',
      submit: '登 录',
      noAccount: '还没有账号？',
      registerNow: '立即注册',
      backHome: '返回首页',
      usernameRequired: '请输入用户名',
      passwordRequired: '请输入密码',
      success: '登录成功',
      failed: '登录失败'
    },
    register: {
      title: '用户注册',
      desc: '注册即送 50 积分，上传资料审核通过可获更多积分',
      username: '用户名（4-20位）',
      name: '昵称/姓名',
      email: '邮箱',
      password: '密码（6位以上）',
      inviteCode: '邀请码（选填，双方各得积分）',
      confirmPassword: '确认密码',
      submit: '注 册',
      hasAccount: '已有账号？',
      loginNow: '立即登录',
      backHome: '返回首页',
      usernameRequired: '请输入用户名',
      usernameLength: '用户名长度 4-20 位',
      nameRequired: '请输入昵称',
      emailRequired: '请输入邮箱',
      emailInvalid: '邮箱格式不正确',
      passwordRequired: '请输入密码',
      passwordMin: '密码至少 6 位',
      confirmRequired: '请确认密码',
      passwordMismatch: '两次输入密码不一致',
      success: '注册成功！已获得 {n} 积分奖励',
      failed: '注册失败'
    }
  },
  user: {
    layout: {
      backHome: "返回首页",
      title: "个人中心",
      pointsN: "{n} 积分",
      logoutAria: "退出登录",
      overview: "概览",
      upload: "上传资料",
      myUploads: "我的上传",
      uploadSoftware: "上传软件",
      mySoftware: "我的软件",
      myProjects: "我的项目",
      messages: "消息中心",
      favorites: "我的收藏",
      invite: "邀请",
      teamPacks: "班组包",
      questions: "我的问答",
      buyPoints: "购买积分",
      pointsHistory: "积分明细",
      changePassword: "修改密码",
      logout: "退出登录",
      passwordSuccess: "密码修改成功，请重新登录",
      logoutSuccess: "已退出登录"
    },
    titles: {
      center: "个人中心",
      upload: "上传资料",
      uploadSoftware: "上传软件",
      mySoftware: "我的软件",
      myProjects: "我的项目",
      messages: "消息中心",
      favorites: "我的收藏",
      invite: "班组邀请",
      teamPacks: "班组资料包",
      questions: "我的问答",
      points: "积分明细",
      buyPoints: "购买积分"
    },
    status: {
      pending: "待审核",
      published: "已发布",
      rejected: "未通过",
      draft: "草稿",
      listed: "已上架"
    },
    center: {
      welcomeTitle: "欢迎加入电力技术资料分享平台",
      welcomeBody: "已为你赠送 {n} 积分。完成下列新手任务，快速上手找资料与分享。",
      recommendFree: "推荐免费资料：",
      hello: "你好，{name}",
      helloHint: "上传优质技术资料，审核通过即可获得积分奖励",
      currentPoints: "当前积分",
      buyPoints: "购买积分",
      onboardingTitle: "新手任务",
      taskBrowse: "浏览 1 篇免费资料",
      taskComment: "发表 1 条评论",
      taskFavorite: "收藏 1 篇资料",
      taskUpload: "了解如何上传资料",
      actionBuyTitle: "购买积分",
      actionBuyDesc: "微信/支付宝快捷充值",
      actionUploadTitle: "上传资料",
      actionUploadDesc: "分享您的技术文档",
      actionFavTitle: "我的收藏",
      actionFavDesc: "回访已收藏资料",
      actionRedeemTitle: "兑换资料",
      actionRedeemDesc: "使用积分兑换资料",
      contribTitle: "我的贡献影响力",
      viewPublicProfile: "查看公开主页",
      noBadges: "尚未获得徽章，继续分享即可解锁",
      published: "已发布",
      downloads: "下载",
      favorited: "获藏",
      thisWeek: "本周",
      contribRules: "活跃贡献者：发布≥3 且下载≥30；领域专家：发布≥5，且单分类≥3 或下载≥200",
      loadingContrib: "加载贡献数据中…",
      pointsRulesTitle: "积分规则",
      ruleRegister: "新用户注册赠送 {n} 积分",
      ruleApproval: "上传资料审核通过奖励 {base} 积分，每含 1 个附件额外 +{per} 积分",
      rulePurchase: "也可通过 {pay} 购买积分套餐，即时到账",
      ruleRedeem: "积分资料可使用积分兑换，兑换后可阅读全文并下载附件",
      wechatAlipay: "微信/支付宝",
      recentPoints: "最近积分变动",
      viewAll: "查看全部"
    },
    messages: {
      title: "消息中心",
      markAllRead: "全部标为已读",
      empty: "暂无消息。资料审核通过或驳回后，会在这里通知你。",
      reward: "已获 {n} 积分",
      typeApproved: "审核通过",
      typeRejected: "审核驳回",
      typeNotify: "通知",
      markedAll: "已全部标为已读"
    },
    invite: {
      title: "班组邀请",
      desc: "把链接发给同事。对方用邀请码注册后，双方各得 {n} 积分。",
      copyLink: "复制邀请链接",
      teamIntro: "培训主管一页介绍",
      invitedCount: "已邀请 {n} 人",
      copied: "已复制",
      copyFailed: "复制失败"
    },
    favorites: {
      title: "我的收藏",
      desc: "收藏的资料便于随时回访与分享",
      empty: "暂无收藏，去资料库挑几篇吧",
      browse: "浏览资料",
      loadFailed: "加载收藏失败"
    },
    myProjects: {
      colTitle: "标题",
      colStatus: "状态",
      colBudget: "预算",
      colPoints: "积分",
      colSubmitted: "提交时间",
      empty: "登录后发布的项目会显示在这里。未登录提交的项目无法在此查看。"
    },
    mySoftware: {
      title: "我的软件",
      upload: "上传软件",
      colName: "名称",
      colType: "类型",
      colStatus: "状态",
      colDownloads: "下载",
      colReject: "审核说明"
    },
    myArticles: {
      title: "我的上传",
      uploadNew: "上传新资料",
      approvedTitle: "《{title}》已通过审核",
      docFallback: "资料",
      rewardSuffix: "，已获 {n} 积分",
      uploadAgain: "再传一篇",
      viewPublished: "查看已发布",
      reviewHint: "待审资料目标 24–48 小时内完成审核，结果会通过站内消息通知你。",
      colTitle: "标题",
      colCategory: "分类",
      colStatus: "状态",
      colAttachments: "附件",
      colViews: "阅读",
      colSubmitted: "提交时间",
      colActions: "操作",
      rejectDefault: "不符合发布要求",
      rewardGot: "已获 {n} 积分",
      view: "查看",
      reupload: "重新上传",
      empty: "暂无上传记录",
      uploadNow: "立即上传",
      etaOverdue: "已等待 {hours} 小时，超过 48h SLA，我们会优先处理",
      etaWarn: "已等待 {hours} 小时，预计尽快完成（目标 48 小时内）",
      etaNormal: "预计 {warn}–{target} 小时内完成 · 已等待 {hours} 小时（约剩 {remain}h）"
    },
    myQuestions: {
      title: "我的问答",
      desc: "跟进你提出的问题，以及待你回复的投稿提问",
      tabAsked: "我提出的",
      tabPending: "待我回复",
      articleFallback: "资料 #{id}",
      answered: "已回答",
      pending: "待回复",
      answersN: "{n} 条回答",
      lastReplyPrefix: "最近回复",
      pinned: "置顶",
      goArticle: "去资料页查看 / 回复",
      emptyPending: "暂无待回复提问",
      emptyAsked: "还没有提问，去资料详情点「我对这份资料有疑问」",
      browse: "浏览资料"
    },
    buyPoints: {
      title: "购买积分",
      current: "当前积分：{n}，支付成功后积分即时到账",
      recommended: "推荐",
      pointsUnit: "积分",
      bonusTip: "含赠送 {n} 积分",
      payMethod: "支付方式",
      methodWechat: "微信支付",
      methodAlipay: "支付宝",
      package: "套餐",
      packageSummary: "{label}（{n} 积分）",
      amountDue: "应付金额",
      payNow: "立即支付",
      payTip: "将跳转至微信/支付宝官方收银台完成付款",
      successTitle: "支付成功",
      successDesc: "积分已到账，您可以继续浏览和兑换资料",
      purchased: "本次购买",
      purchasedPoints: "+{n} 积分",
      totalPoints: "当前积分总数",
      totalPointsN: "{n} 积分",
      gotIt: "知道了",
      wechatTitle: "微信扫码支付",
      payAmount: "支付金额：¥{amount}",
      qrAlt: "微信支付二维码",
      wechatHint: "请使用微信扫一扫完成支付",
      waitingPay: "等待支付结果...",
      confirmPay: "确认使用{method}支付 ¥{price}，购买 {n} 积分？",
      confirmTitle: "确认支付",
      goPay: "去支付",
      createOrderFailed: "创建支付订单失败",
      orderFailed: "创建订单失败",
      allowPopup: "请允许浏览器弹出窗口以完成支付宝支付"
    },
    pointsHistory: {
      current: "当前积分",
      buy: "购买积分",
      title: "积分明细",
      colTime: "时间",
      colDesc: "说明",
      colChange: "变动",
      colType: "类型",
      empty: "暂无积分记录",
      typeEarn: "奖励",
      typePurchase: "购买",
      typeSpend: "消费",
      typeAdmin: "管理员调整"
    },
    teamPacks: {
      title: "班组资料包",
      desc: "把收藏整理成只读资料包，发给班组同事即可一起看，不能改你的收藏。",
      create: "新建资料包",
      articlesN: "{n} 篇",
      manage: "管理",
      copyLink: "复制只读链接",
      delete: "删除",
      empty: "还没有班组资料包",
      createTitle: "新建资料包",
      namePlaceholder: "例如：变电一班培训包",
      cancel: "取消",
      createBtn: "创建",
      packFallback: "资料包",
      shareLink: "只读链接：{url}",
      importFav: "从我的收藏导入",
      articleId: "资料 ID",
      add: "加入",
      remove: "移除",
      linkCopied: "只读链接已复制",
      deleteConfirm: "删除「{name}」？",
      tip: "提示",
      imported: "已导入收藏",
      createFailed: "创建失败"
    },
    uploadSoftware: {
      title: "上传软件",
      tip: "审核通过后按基础 100 分 + 每个安装包 20 分奖励积分。建议类型由管理员最终确认。",
      name: "名称",
      summary: "简介",
      description: "详细说明",
      version: "版本",
      versionPlaceholder: "例如 1.0.0",
      platform: "平台",
      suggestType: "建议类型",
      typeFree: "免费",
      typePaid: "积分兑换",
      suggestPoints: "建议积分",
      packages: "安装包",
      dragHint: "将安装包拖到此处，或点击上传（单个最大 2GB）",
      uploading: "正在上传，大文件请耐心等待...",
      remove: "移除",
      submit: "提交审核",
      platformTool: "工具",
      platformPlugin: "插件",
      platformOther: "其他",
      uploadDone: "上传完成",
      uploadFailed: "上传失败",
      fillRequired: "请填写名称和简介",
      needPackage: "请上传安装包",
      submitSuccess: "已提交，等待审核",
      submitFailed: "提交失败"
    },
    upload: {
      title: "上传技术资料",
      desc: "预计 {minutes} 分钟可完成投稿。提交后 {sla} 小时内审核；通过预计获得 {reward} 积分（基础 {base} + 每附件 +{per}）。请确认资料非涉密且您有权分享。",
      minutes: "10",
      sla: "24–48",
      draftSaving: "保存中…",
      draftSavedPrefix: "草稿已自动保存",
      draftHint: "输入内容将自动保存草稿",
      draftBannerTitle: "检测到未提交草稿",
      draftBannerBody: "可继续编辑上次内容，或清空后重新填写。",
      restoreDraft: "恢复草稿",
      discardDraft: "丢弃草稿",
      checkTitle: "标题",
      checkCategory: "分类",
      checkSummary: "摘要",
      checkContent: "正文",
      checkFile: "附件（可选）",
      templatesLabel: "一键套用模板：",
      tplSafety: "电力安全",
      tplRenewable: "新能源并网",
      tplDistribution: "配电工程",
      tplTransmission: "输电技术",
      tplSubstation: "变电运维",
      labelTitle: "资料标题",
      titlePlaceholder: "示例：光伏电站并网验收资料清单与常见驳回原因",
      labelCategory: "资料分类",
      categoryPlaceholder: "选择分类（优先选择缺口较大的分类）",
      labelAuthor: "作者署名",
      authorPlaceholder: "显示在资料上的作者名",
      labelSummary: "资料摘要",
      summaryPlaceholder: "用 2–3 句话说明适用场景、核心价值（便于检索）",
      labelContent: "资料内容",
      contentPlaceholder: "可先套用模板，再替换为你的实操经验、规范要点与案例",
      labelFiles: "附件上传",
      dragHint: "将文件拖到此处，或{em}",
      clickUpload: "点击上传",
      uploadTip: "支持 {ext}；单文件不超过 {size}。建议附 PDF/Word 规范原文或检查表。",
      maxSize: "50MB",
      uploading: "正在上传附件…",
      remove: "移除",
      submitHint: "提交后预计审核 {sla} 小时；通过可获约 {reward} 积分。",
      declaration: "我确认资料非涉密，且我有权分享",
      submit: "提交审核",
      saveDraft: "保存草稿",
      reset: "重置",
      ruleTitle: "请输入标题",
      ruleSummary: "请输入摘要",
      ruleContent: "请输入内容",
      ruleCategory: "请选择分类",
      ruleAuthor: "请输入作者署名",
      draftSavedLocal: "草稿已保存到本机",
      draftRestored: "已恢复草稿",
      draftDiscarded: "已丢弃草稿",
      templateApplied: "已套用「{label}」模板，请按需修改后提交",
      templateConfirm: "套用模板将覆盖当前标题/摘要/正文，是否继续？",
      templateTitle: "套用模板",
      templateOverwrite: "覆盖并套用",
      badFileType: "不支持的文件类型，请上传：{ext}",
      fileTooLarge: "文件大小不能超过 50MB",
      uploadedFile: "已上传：{name}",
      uploadFailed: "上传失败",
      resetConfirm: "确定清空表单？本机草稿也会删除。",
      resetTitle: "重置",
      needDeclaration: "请勾选「非涉密、有权分享」",
      submitSuccessTitle: "提交成功",
      submitSuccessHtml: "<p>资料已进入审核队列。</p><ul style=\"padding-left:18px;line-height:1.8;margin:12px 0\"><li>预计审核时间：<strong>24–48 小时</strong></li><li>审核通过预计积分：<strong>{reward}</strong>（基础 {base} + 附件 {files}×{per}）</li><li>可在「我的上传」查看进度</li></ul>",
      viewMyUploads: "查看我的上传",
      submitFailed: "提交失败"
    }
  }
}
